import React from "react";

/**
 * Stand-in for /location while its chunk (leaflet + react-leaflet) downloads.
 *
 * The app-wide Suspense fallback is HomeSkeleton — a job-list skeleton, which on the way
 * to a map reads as the wrong page having loaded. This paints the map's own shape
 * instead: the basemap tint, the floating chip row and a spinner where the pins land.
 */
const MapSkeleton = () => (
  <div
    className="fixed top-16 left-0 right-0 bottom-0 z-10 overflow-hidden"
    style={{ background: "var(--map-bg, #eaeef2)" }}
  >
    {/* the category chips that sit over the real map */}
    <div className="absolute top-3 left-0 right-0 px-3 flex gap-2 overflow-hidden">
      {[72, 96, 88, 80].map((w, i) => (
        <span key={i} className="h-11 rounded-full bg-white/80 animate-pulse" style={{ width: w }} />
      ))}
    </div>
    <div className="absolute inset-0 flex items-center justify-center">
      <span className="w-8 h-8 rounded-full border-2 border-[#020618] border-t-transparent animate-spin" />
    </div>
  </div>
);

export default MapSkeleton;
